const notificationTemplates = [
	{
		path: '/network/notification-templates',
		name: 'network-notification-templates-list',
		component: () => import('@/views/notifications/templates/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,notifications',
		},
	},
]

export default notificationTemplates
